module.exports = __webpack_public_path__ + "img/812367e.jpg";